module.exports = __webpack_public_path__ + "img/ciaz.f3bfdae4.png";